export const API_ENDPOINTS = {
    documents: {
        findAll: `/document/findAll`,
        getDocumentById: `/document`,
        download: `/document/getDocument`,
        downloadZip: `/document/zip`,
        activate: `/document/activate`,
        delete: `/document/delete`,
        downloader: {
            findAll: `/document/downloader/findAll`,
        }
    },
    staticdata: '/staticdata/',
    config: {
      portal: `/portal`,
    },
    fidesPortal: {
        applications: 'fidesportal/administration/users/applications',
        user: 'fidesportal/auth/user',
        refreshToken: 'fidesportal/auth/refresh'
    },
    version: 'version',
}